import { Check, CircleAlert } from 'lucide-react';

export function Toast({ message, error = false }: { message: string; error?: boolean }) {
  if (!message) return null;
  return (
    <div role="status" className={`fixed bottom-5 left-1/2 z-[80] flex -translate-x-1/2 items-center gap-2 rounded-full border px-4 py-2.5 text-sm shadow-popover ${error ? 'border-danger/40 bg-surface-raised text-danger' : 'border-border bg-surface-raised text-primary'}`}>
      {error ? <CircleAlert className="size-4" /> : <Check className="size-4 text-success" />}{message}
    </div>
  );
}
